import TermsContent from 'src/components/affiliate/TermsContent'
import {
    Card,
    Muted,
    Narrow,
    Page,
    PageTitle,
} from 'src/components/affiliate/ui'
import { usePublicProgram } from 'src/hooks/useAffiliate'

/** /affiliate/terms: public, so it can be linked from the application form and shared before signing in. */
const AffiliateTermsPage = () => {
    const program = usePublicProgram()

    return (
        <Page>
            <Narrow>
                <div>
                    <PageTitle>SwiftSole Affiliate Terms</PageTitle>
                    {program.data && (
                        <Muted>Version {program.data.termsVersion}</Muted>
                    )}
                </div>
                <Card>
                    <TermsContent program={program.data} />
                </Card>
            </Narrow>
        </Page>
    )
}

export default AffiliateTermsPage
